/* Beach Camera — site-search gate.
   Only products flagged custom.searchable=true appear in on-site search.
   Control: flip the "Searchable (site search)" metafield on any product.
   Requires: Search & Discovery filter on custom.searchable (one-time app setup).
   Whitelist for the predictive dropdown lives in assets/bc-searchable.json. */
(function () {
  var PARAM = 'filter.p.m.custom.searchable';
  var VALUE = 'true';

  /* 1. Every search form submits with the filter applied */
  function armForms(root) {
    var forms = (root || document).querySelectorAll('form[action*="/search"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('input[name="' + PARAM + '"]')) continue;
      var inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = PARAM; inp.value = VALUE;
      forms[i].appendChild(inp);
    }
  }
  armForms();
  new MutationObserver(function () { armForms(); }).observe(document.documentElement, { childList: true, subtree: true });

  /* 2. Direct hits on /search?q=... (old links, typed URLs) get the filter added */
  if (location.pathname === '/search' && location.search.indexOf('q=') !== -1 && location.search.indexOf(PARAM) === -1) {
    var u = new URL(location.href);
    u.searchParams.set(PARAM, VALUE);
    location.replace(u.toString());
  }

  /* 3. Predictive dropdown (suggest.json can't filter) — trim to the whitelist */
  var allowed = null;
  function loadAllowed() {
    if (allowed) return allowed;
    allowed = fetch(window.BC_SEARCHABLE_URL || '/cdn/shop/t/[[THEME]]/assets/bc-searchable.json')
      .then(function (r) { return r.json(); })
      .then(function (list) { var s = {}; for (var i = 0; i < list.length; i++) s['/products/' + list[i]] = 1; return s; })
      .catch(function () { return null; });
    return allowed;
  }
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    if (url.indexOf('suggest.json') === -1) return _fetch.apply(this, arguments);
    return Promise.all([_fetch.apply(this, arguments), loadAllowed()]).then(function (pair) {
      var res = pair[0], ok = pair[1];
      if (!ok) return res;
      return res.clone().json().then(function (data) {
        try {
          var prods = data && data.resources && data.resources.results && data.resources.results.products;
          if (prods) {
            data.resources.results.products = prods.filter(function (p) {
              var path = (p.url || '').split('?')[0];
              return ok[path] === 1;
            });
          }
        } catch (e) {}
        return new Response(JSON.stringify(data), { status: res.status, headers: { 'Content-Type': 'application/json' } });
      }).catch(function () { return res; });
    });
  };
})();
